module.exports = __webpack_public_path__ + "img/logo.d9eb2855.jpg";